import IconBase from './IconBase';
import { IconProps } from './types';

const size20Path = <path d="M389-267 195-460l51-52 143 143 325-324 51 51-376 375Z" />;
const size24Path = <path d="M382-240 154-468l57-57 171 171 367-367 57 57-424 424Z" />;

export default function CheckIcon(props: IconProps) {
  return <IconBase {...props} size20Component={size20Path} size24Component={size24Path} />;
}
